/* ============================================================
   PLATEAUX EVENEMENTS — SOURCE TEMPORAIRE I18N

   IMPORTANT :
   - données locales temporaires
   - à remplacer plus tard par les données backend / dashboard admin
   - prix stockés en centimes pour compatibilité panier / tunnel
   - heroImage sert à l’image héro de la page plateaux

   NOUVEAU FORMAT :
   - nom: objet multilingue { fr, de, en }
   - description: objet multilingue { fr, de, en }

   BUT :
   - permettre l’affichage correct selon la langue active
   ============================================================ */

export const plateauxData = [
  {
    id: "plateau_apero_fromage",
    nom: {
      fr: "Plateau apéro fromage",
      de: "Aperoplatte Käse",
      en: "Cheese aperitif platter",
    },
    description: {
      fr: "80g de fromage par personne",
      de: "80 g Käse pro Person",
      en: "80g of cheese per person",
    },
    prix: 600,
    heroImage: "plateaux-evenements-hero.jpg",
    image: "plateau-apero-fromage.jpg",
  },

  {
    id: "plateau_apero_mixte",
    nom: {
      fr: "Plateau apéro viande et fromage",
      de: "Aperoplatte Fleisch und Käse",
      en: "Meat and cheese aperitif platter",
    },
    description: {
      fr: "70g fromage et 30g viande par personne",
      de: "70 g Käse und 30 g Fleisch pro Person",
      en: "70g cheese and 30g meat per person",
    },
    prix: 800,
    heroImage: "plateaux-evenements-hero.jpg",
    image: "plateau-apero-mixte.jpg",
  },

  {
    id: "plateau_repas_fromage",
    nom: {
      fr: "Plateau repas fromage",
      de: "Mahlzeitplatte Käse",
      en: "Cheese meal platter",
    },
    description: {
      fr: "200g de fromage par personne",
      de: "200 g Käse pro Person",
      en: "200g of cheese per person",
    },
    prix: 1400,
    heroImage: "plateaux-evenements-hero.jpg",
    image: "plateau-repas-fromage.jpg",
  },

  {
    id: "plateau_repas_mixte",
    nom: {
      fr: "Plateau repas viande et fromage",
      de: "Mahlzeitplatte Fleisch und Käse",
      en: "Meat and cheese meal platter",
    },
    description: {
      fr: "150g fromage et 50g viande par personne",
      de: "150 g Käse und 50 g Fleisch pro Person",
      en: "150g cheese and 50g meat per person",
    },
    prix: 1500,
    heroImage: "plateaux-evenements-hero.jpg",
    image: "plateau-repas-mixte.jpg",
  },

  {
    id: "plateau_dessert",
    nom: {
      fr: "Plateau dessert fromage",
      de: "Dessertplatte Käse",
      en: "Cheese dessert platter",
    },
    description: {
      fr: "80g de fromage par personne",
      de: "80 g Käse pro Person",
      en: "80g of cheese per person",
    },
    prix: 600,
    heroImage: "plateaux-evenements-hero.jpg",
    image: "plateau-dessert-fromage.jpg",
  },
];
